import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IPartnerSearchCtrlScope {
  partnerSearchCtrl: PartnerSearchCtrl;
}

export class PartnerSearchCtrl {
  private showLogging: boolean = false;
  private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
  public partners: Models.PartnerModel.IPartnerModel[];
  public partnerToAdd: Models.PartnerModel.PartnerModel;

  public static $inject = [
    "$scope",
    "$state",
    "UserService",
    "PartnerRetrievalService",
    "PartnerSaveService",
    "igs.messageBox",
  ];

  constructor(
    $scope: IPartnerSearchCtrlScope,
    private $state: angular.ui.IStateService,
    private userService: Services.UserService.IUserService,
    private partnerRetrievalService: UserManagement.services.PartnerRetrievalService.IPartnerRetrievalService,
    private partnerSaveService: UserManagement.services.PartnerSaveService.IPartnerSaveService,
    private messageBox: any,
  ) {
    $scope.partnerSearchCtrl = this;
    // Only user admins can manage partners
    this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
      if (response === false) {
        this.$state.go("main.customersearchv2");
      }
    });

    this.getAndSetPartners();
    this.clearPartnerToAdd();
  }

  public getAndSetPartners(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("setting partners...");
    }
    return this.partnerRetrievalService.getPartners(true).then((partners: Models.PartnerModel.IPartnerModel[]) => {
      this.partners = _.sortBy(partners, "name");
    });
  }

  public createPartner = () => {
    // basic validation
    if (this.showLogging) {
      console.log("creating partner...");
    }
    if (
      !this.partnerToAdd ||
      !this.partnerToAdd.name ||
      !this.partnerToAdd.code ||
      this.partnerToAdd.name.length <= 0 ||
      this.partnerToAdd.code.length <= 0
    ) {
      toastr.error("Please enter a valid partner name and code", "Error");
      return;
    }
    this.partnerToAdd.name = this.partnerToAdd.name.trim();
    this.partnerToAdd.code = this.partnerToAdd.code.trim().toUpperCase().replace(/\s/g, "");

    // check to make sure user does not try to add partner/code that already exists
    if (
      _.some(this.partners, (p: Models.PartnerModel.IPartnerModel) => {
        return p.name === this.partnerToAdd.name || p.code === this.partnerToAdd.code;
      })
    ) {
      toastr.error("The provided name and/or code has already been used", "Error");
      return;
    }

    //confirm
    var openBox = this.messageBox.open("Create New Partner", "Are you sure you want to create this new partner?", [
      { label: "OK", cssClass: "btn-success", result: true },
      { label: "Cancel", cssClass: "btn-cancel", result: false },
    ]);

    //save
    openBox.then((result: boolean) => {
      if (result) {
        this.partnerSaveService.savePartner(this.partnerToAdd).then(
          () => {
            this.$state.reload();
            toastr.success("Partner Added", "Success");
          },
          () => {
            toastr.error("There was a problem saving the partner", "Error");
          },
        );
      }
    });
  };

  public clearPartnerToAdd = () => {
    this.partnerToAdd = new Models.PartnerModel.PartnerModel("", "");
  };
}
